module.exports = __webpack_public_path__ + "img/HBOMAX.9d386b31.png";